module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkin-cell",
    class: {
      'open-up': _vm.shouldDropdownOpenUp
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "mouseleave": _vm.onMouseLeave
    }
  }, [_c('div', {
    staticClass: "display",
    class: {
      disabled: _vm.isDisabled,
      bold: !(_vm.checkinInfo.isCancelled || _vm.isPendingOrDue)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggle.apply(null, arguments)
      }
    }
  }, [(_vm.checkinInfo.isCancelled || _vm.isPendingOrDue) ? _c('span', [_vm._v("- | -")]) : (_vm.checkinInfo.checked === 0 && _vm.checkinInfo.noShow === 0) ? _c('span', [_vm._v("Not checked in")]) : _c('span', [_vm._v(_vm._s(_vm.checkinInfo.checked) + " | " + _vm._s(_vm.checkinInfo.noShow))]), _vm._v(" "), (!_vm.isDisabled) ? _c('span', {
    staticClass: "dropdown-arrow",
    class: {
      open: _vm.open
    }
  }, [_vm._v("▾")]) : (_vm.loading) ? _c('loader', {
    attrs: {
      "size": "small"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.open) ? _c('ul', {
    staticClass: "menu",
    class: {
      bold: !(_vm.checkinInfo.isCancelled || _vm.isPendingOrDue)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('li', {
    class: {
      disabled: _vm.loading || !_vm.isCheckedEnabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        !_vm.loading && _vm.isCheckedEnabled && _vm.select(_vm.checkinActions.CHECKED)
      }
    }
  }, [_vm._v("Checked in")]), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.loading || !_vm.isNoShowEnabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        !_vm.loading && _vm.isNoShowEnabled && _vm.select(_vm.checkinActions.NOSHOW)
      }
    }
  }, [_vm._v("No-show")]), _vm._v(" "), _c('li', {
    class: {
      disabled: _vm.loading
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        !_vm.loading && _vm.select(_vm.checkinActions.PER_CLIENT)
      }
    }
  }, [_vm._v("Check-in per client")])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-51437a1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51437a1a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/reservationLists/CheckinDropdown.vue
// module id = 2765
// module chunks = 0